"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAddSyncSlice = createAddSyncSlice;
exports.createRemoveSyncSlice = createRemoveSyncSlice;
exports.createUpdateSyncSlice = createUpdateSyncSlice;
exports.createAddCollectionSyncSlice = createAddCollectionSyncSlice;
exports.createRemoveCollectionSyncSlice = createRemoveCollectionSyncSlice;
exports.createUpdateCollectionSyncSlice = createUpdateCollectionSyncSlice;
const Verbs_1 = require("../types/Verbs.js");
const lib_1 = require("../redux/lib.js");
function createAddSyncSlice(options) {
    return (0, lib_1.createSyncRedux)(Object.assign(Object.assign({}, options), { syncVerb: Verbs_1.SyncVerb.Add }));
}
function createRemoveSyncSlice(options) {
    return (0, lib_1.createSyncRedux)(Object.assign(Object.assign({}, options), { syncVerb: Verbs_1.SyncVerb.Remove }));
}
function createUpdateSyncSlice(options) {
    return (0, lib_1.createSyncRedux)(Object.assign(Object.assign({}, options), { syncVerb: Verbs_1.SyncVerb.Update }));
}
function createAddCollectionSyncSlice(options) {
    return (0, lib_1.createCollectionSyncRedux)(Object.assign(Object.assign({}, options), { syncVerb: Verbs_1.SyncVerb.Add }));
}
function createRemoveCollectionSyncSlice(options) {
    return (0, lib_1.createCollectionSyncRedux)(Object.assign(Object.assign({}, options), { syncVerb: Verbs_1.SyncVerb.Remove }));
}
function createUpdateCollectionSyncSlice(options) {
    return (0, lib_1.createCollectionSyncRedux)(Object.assign(Object.assign({}, options), { syncVerb: Verbs_1.SyncVerb.Update }));
}
//# sourceMappingURL=lib.js.map